import { EntityModel } from '@/interfaces'
import {
  ALL_ACCOMMODATION_ASSIGNMENTS_QUERY,
  CREATE_ACCOMMODATION_ASSIGNMENT_MUTATION,
  DELETE_ACCOMMODATION_ASSIGNMENT_MUTATION,
  FORCE_DELETE_ACCOMMODATION_ASSIGNMENT_MUTATION,
  SINGLE_ACCOMMODATION_ASSIGNMENT_QUERY,
  UPDATE_ACCOMMODATION_ASSIGNMENT_MUTATION,
} from './graphql'
import accommodationEntity from '@/entities/accommodation/entity'
import accommodationRoomTypeEntity from '@/entities/accommodationRoomType/entity'

const travelAccommodationAssignmentModel: EntityModel = {
  name: 'accommodationAssignment',
  namePlural: 'accommodationAssignments',
  uniqueName: 'travelAccommodationAssignment',
  uniqueNamePlural: 'travelAccommodationAssignments',
  path: 'travel/accommodation_assignment',
  baseUrl: '/travel/accommodation_assignments',
  translationPrefix: 'entities:travelAccommodationAssignment.',
  getDisplayName: (values: any) => {
    return ''
  },
  gql: {
    getAll: ALL_ACCOMMODATION_ASSIGNMENTS_QUERY,
    getSingle: SINGLE_ACCOMMODATION_ASSIGNMENT_QUERY,
    create: CREATE_ACCOMMODATION_ASSIGNMENT_MUTATION,
    update: UPDATE_ACCOMMODATION_ASSIGNMENT_MUTATION,
    delete: DELETE_ACCOMMODATION_ASSIGNMENT_MUTATION,
    forceDelete: FORCE_DELETE_ACCOMMODATION_ASSIGNMENT_MUTATION,
  },
  attributes: {
    accommodation: {
      name: 'accommodation',
      label: 'entities:travelAccommodationAssignment.attributes.accommodation.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return accommodationEntity
      },
      defaultInput: true,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    roomTypes: {
      name: 'roomTypes',
      label: 'entities:travelAccommodationAssignment.attributes.roomTypes.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return accommodationRoomTypeEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    useCustomRoomTypeSelection: {
      name: 'useCustomRoomTypeSelection',
      label: 'entities:travelAccommodationAssignment.attributes.useCustomRoomTypeSelection.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: false,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
    displayDetails: {
      name: 'displayDetails',
      label: 'entities:travelAccommodationAssignment.attributes.displayDetails.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: false,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
  },
}

export default travelAccommodationAssignmentModel
